<div fxLayout fxLayoutAlign="space-apart center" fxLayoutGap="12px">
  <sbnb-save-indicator [saveStatus]="saveStatus"></sbnb-save-indicator>
</div>

<div class="rule__section-container">
  <h3>Getting Paid</h3>
  <p class="smoke-darker">Coming soon</p>
</div>
